export default "__VITE_ASSET__Dc78yWgo__"